import React from 'react';
import { Helmet } from 'react-helmet-async';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>תנאי שימוש - Auto Cross</title>
        <meta name="description" content="תנאי השימוש של אתר Auto Cross - יבוא ומכירת רכבים ומוניות" />
      </Helmet>
      
      <div className="terms-page">
        <div className="container">
          <header>
            <h1>תנאי שימוש</h1>
            <p className="last-updated">עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</p>
          </header>

          <main>
            <section aria-labelledby="general-terms-title">
              <h2 id="general-terms-title">תנאים כלליים</h2>
              <p>
                ברוכים הבאים לאתר Auto Cross. השימוש באתר זה כפוף לתנאים המפורטים להלן. 
                על ידי גישה לאתר ושימוש בו, אתם מסכימים לתנאים אלה במלואם.
              </p>
            </section>

            <section aria-labelledby="services-title">
              <h2 id="services-title">השירותים שלנו</h2>
              <p>Auto Cross מתמחה ב:</p>
              <ul>
                <li>יבוא רכבים פרטיים ומסחריים</li>
                <li>מכירת מוניות חדשות ויד שנייה</li>
                <li>שירותי מימון והלוואות לרכב</li>
                <li>שירותי אחריות ותחזוקה</li>
                <li>ייעוץ מקצועי בתחום הרכב</li>
              </ul>
            </section>

            <section aria-labelledby="user-obligations-title">
              <h2 id="user-obligations-title">התחייבויות המשתמש</h2>
              <p>בעת השימוש באתר, אתם מתחייבים:</p>
              <ul>
                <li>לספק מידע מדויק ועדכני</li>
                <li>לא להשתמש באתר למטרות בלתי חוקיות</li>
                <li>לכבד זכויות יוצרים וקניין רוחני</li>
                <li>לא לפגוע בתפעול האתר או במשתמשים אחרים</li>
                <li>לשמור על סודיות פרטי הגישה שלכם</li>
              </ul>
            </section>

            <section aria-labelledby="pricing-payment-title">
              <h2 id="pricing-payment-title">מחירים ותשלומים</h2>
              <ul>
                <li>כל המחירים באתר כוללים מע"מ אלא אם צוין אחרת</li>
                <li>המחירים עשויים להשתנות ללא הודעה מוקדמת</li>
                <li>התשלום יבוצע בהתאם לתנאים שיוסכמו בחוזה המכירה</li>
                <li>אנו שומרים לעצמנו את הזכות לבטל עסקה במקרה של טעות במחיר</li>
              </ul>
            </section>

            <section aria-labelledby="warranty-title">
              <h2 id="warranty-title">אחריות ושירות</h2>
              <p>
                אנו מעניקים אחריות על הרכבים שאנו מוכרים בהתאם לתנאי היצרן ו/או 
                לתנאים המפורטים בחוזה המכירה. פרטי האחריות יימסרו בעת הרכישה.
              </p>
            </section>

            <section aria-labelledby="liability-title">
              <h2 id="liability-title">הגבלת אחריות</h2>
              <p>
                Auto Cross לא תהיה אחראית לכל נזק עקיף, תוצאתי או מיוחד הנובע 
                משימוש באתר או מהשירותים. האחריות שלנו מוגבלת לשווי העסקה בלבד.
              </p>
            </section>

            <section aria-labelledby="intellectual-property-title">
              <h2 id="intellectual-property-title">קניין רוחני</h2>
              <p>
                כל התוכן באתר, לרבות טקסטים, תמונות, לוגו ועיצוב, הם קניינה הרוחני 
                של Auto Cross או של צדדים שלישיים. אסור להעתיק, להפיץ או להשתמש 
                בתוכן ללא אישור מפורש בכתב.
              </p>
            </section>

            <section aria-labelledby="privacy-title">
              <h2 id="privacy-title">פרטיות</h2>
              <p>
                השימוש באתר כפוף גם למדיניות הפרטיות שלנו. אנו מתחייבים לשמור על 
                פרטיותכם ולהשתמש במידע שלכם אך ורק למטרות המפורטות במדיניות הפרטיות.
              </p>
            </section>

            <section aria-labelledby="changes-title">
              <h2 id="changes-title">שינויים בתנאים</h2>
              <p>
                אנו שומרים לעצמנו את הזכות לעדכן את תנאי השימוש מעת לעת. 
                שינויים יכנסו לתוקף מיד עם פרסומם באתר. המשך השימוש באתר 
                לאחר השינויים מהווה הסכמה לתנאים החדשים.
              </p>
            </section>

            <section aria-labelledby="governing-law-title">
              <h2 id="governing-law-title">דין חל וסמכות שיפוט</h2>
              <p>
                תנאי השימוש כפופים לדיני מדינת ישראל. כל מחלוקת תידון בבתי המשפט 
                המוסמכים בישראל בלבד.
              </p>
            </section>

            <section aria-labelledby="contact-title">
              <h2 id="contact-title">יצירת קשר</h2>
              <p>לשאלות או הבהרות בנוגע לתנאי השימוש, ניתן לפנות אלינו:</p>
              
              <div className="contact-info">
                <address>
                  <p>
                    <strong>טלפון:</strong> 
                    <a href="tel:03-3820232" aria-label="התקשר לטלפון 03-3820232">03-3820232</a>
                  </p>
                  <p>
                    <strong>אימייל:</strong> 
                    <a href="mailto:Office@auto-cross.co.il" aria-label="שלח אימייל ל Office@auto-cross.co.il">Office@auto-cross.co.il</a>
                  </p>
                  <p>
                    <strong>כתובת:</strong> התמר 3, אבן יהודה
                  </p>
                </address>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
